// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__6s5pe","Loader1":"Spinner_Loader1__2de9w","Loader2":"Spinner_Loader2__1v7Dm","Loader3":"Spinner_Loader3__y04eh"};